import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@qapline/helpers';
import { Spinner } from '@qapline/ui';

import { useLazyLogoutUserQuery } from '../../api';

export const LogoutPage = () => {
    const [logout] = useLazyLogoutUserQuery();
    const { t } = useTranslation();

    useDocumentTitle(t('nav.logout'));

    useEffect(() => {
        const fetchLogout = async () => {
            try {
                await logout().unwrap();
                toast.success(t('auth.logout.success'));
            } catch (error) {
                toast.error(t('auth.logout.error'));
            }
        };
        fetchLogout();
    }, []);

    return <Spinner fullScreen />;
};
